'use strict';

var keyMirror = require('react/lib/keyMirror');

var VerticalDragAnchors = keyMirror({
  TOP: null,
  CENTER: null,
  BOTTOM: null
});

module.exports = VerticalDragAnchors;


/*****************
 ** WEBPACK FOOTER
 ** ../modules/constants/VerticalDragAnchors.js
 ** module id = 76
 ** module chunks = 0
 **/